<template>
    <div>
        <v-card>
            <v-card-title>
                {{ webhookType }} Webhooks
                <v-btn
                    class="ml-auto"
                    icon
                    @click="tips = !tips">
                    <v-icon dark>
                        mdi-information
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="p-0">
                <v-alert
                    :value="tips"
                    outlined
                    color="primary"
                    dark
                    border="right"
                    transition="scale-transition"
                    class="mx-5">
                    <div class="title">
                        Tips
                    </div>
                    <p v-for="(tip, index) in webhookTips"
                        :key="'tips-' + index">
                        {{ tip }}
                    </p>
                </v-alert>

                <div v-if="integrationId" class="mx-5">
                    <v-progress-linear
                        v-if="isLoading"
                        indeterminate
                        color="primary"
                        class="mb-5">
                    </v-progress-linear>
                    <v-form
                        ref="form">
                        <v-list>
                            <div v-if="type == 'Shopify'">
                                <v-col cols="12" md="12" sm="12" lg="5"  class="p-0">
                                    <div class="d-flex justify-end">
                                        <v-tooltip bottom>
                                            <template slot="activator" slot-scope="{ on }">
                                                <v-btn small :disabled="isLoading" v-on="on" @click="triggerTopic('default', true)">
                                                    <v-icon dark class="mr-3 info-icon-stack">
                                                        mdi-information
                                                    </v-icon>
                                                    Enable Default Webhooks
                                                </v-btn>
                                            </template>
                                            <span>
                                                <strong>Enable the following:</strong><br>
                                                ORDERS/UPDATED<br>
                                                ORDERS/CANCELLED<br>
                                                ORDERS/DELETE<br>
                                                FULFILLMENT_ORDERS/SPLIT<br>
                                                FULFILLMENT_ORDERS/ORDER_ROUTING_COMPLETE<br>
                                                FULFILLMENT_ORDERS/PLACED_ON_HOLD<br>
                                                FULFILLMENT_ORDERS/HOLD_RELEASED
                                            </span>
                                        </v-tooltip>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" lg="5" class="p-0">
                                    <v-list-item class="hoverable-list-item">
                                        <v-list-item-content>
                                            <strong>Available Webhooks</strong>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <strong>Enabled</strong>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" lg="5" class="p-0">
                                    <v-list-item v-for="shopifyHook in shopifyWebhooks" :key="'webhook-' + shopifyHook.text" class="hoverable-list-item">
                                        <v-list-item-content>
                                            {{ shopifyHook.text.toUpperCase() }}
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <v-switch :input-value="hasWebhook(shopifyHook.text)" @change="triggerTopic(shopifyHook.text, $event)" :disabled="isLoading" color="primary" class="mb-0"></v-switch>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-col>
                            </div>

                            <div v-if="type == 'Shopify Update Only'">
                                <v-col cols="12" md="12" sm="12" lg="5" class="p-0">
                                    <v-list-item class="hoverable-list-item">
                                        <v-list-item-content>
                                            <strong>Available Webhooks</strong>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <strong>Enabled</strong>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" lg="5" class="p-0">
                                    <v-list-item class="hoverable-list-item">
                                        <v-list-item-content>
                                            {{ 'app/uninstalled'.toUpperCase() }}
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <v-switch :input-value="hasWebhook('app/uninstalled')" @change="triggerTopic('app/uninstalled', $event)" :disabled="isLoading" color="primary" class="mb-0"></v-switch>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-col>
                            </div>

                            <div v-if="type == 'DEAR Systems'">
                                <v-col cols="12" md="8" sm="12" lg="5" class="p-0">
                                    <v-list-item v-for="dearHook in dearWebhooks" :key="'webhook-' + dearHook.text" class="hoverable-list-item">
                                        <v-list-item-content>
                                            Subscribe to {{ dearHook.text }}
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <v-switch :input-value="hasWebhook(dearHook.text)" @change="triggerTopic(dearHook.text, $event)" :disabled="isLoading" color="primary" class="mb-0"></v-switch>
                                            </div>
                                        </v-list-item-action>

                                    </v-list-item>
                                </v-col>
                            </div>

                            <div v-if="type == 'Unleashed'">
                                <v-col cols="12" md="8" sm="12" lg="5" class="p-0">
                                    <v-list-item v-for="unleashedHook in unleashedWebhooks" :key="'webhook-' + unleashedHook.text" class="hoverable-list-item">
                                        <v-list-item-content>
                                            Subscribe to {{ unleashedHook.text }}
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <v-switch :input-value="hasWebhook(unleashedHook.text)" @change="triggerTopic(unleashedHook.value, $event)" :disabled="isLoading" color="primary" class="mb-0"></v-switch>
                                            </div>
                                        </v-list-item-action>

                                    </v-list-item>
                                </v-col>
                            </div>

                            <div v-if="type == 'BigCommerce'">
                                <v-col cols="12" md="12" sm="12" lg="5" class="p-0">
                                    <v-list-item class="hoverable-list-item">
                                        <v-list-item-content>
                                            <strong>Available Webhooks</strong>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <strong>Enabled</strong>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" md="8" sm="12" lg="5" class="p-0">
                                    <v-list-item v-for="bcHook in bigCommerceWebhooks" :key="'webhook-' + bcHook.text" class="hoverable-list-item">
                                        <v-list-item-content>
                                            {{ bcHook.text.toUpperCase() }}
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div>
                                                <v-switch :input-value="hasWebhook(bcHook.text)" @change="triggerTopic(bcHook.text, $event)" :disabled="isLoading" color="primary" class="mb-0"></v-switch>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-col>
                            </div>

                        </v-list>
                    </v-form>

                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'

export default {
    props: {
        id: { type: Number, default: null },
        type: { type: String, default: "" },
    },

    computed: {
        webhookType() {
            return this.type
        },

        integrationId() {
            return this.id
        },

        hasOrdersCreate() {
            return this.webhooks.some(function(field) {
                return field.topic === 'orders/create'
            });
        },

        hasOrdersUpdated() {
            return this.webhooks.some(function(field) {
                return field.topic === 'orders/updated'
            });
        }
    },


    data() {
        return {
            isLoading: false,
            webhooks: [],
            tips: false,
            webhookTips: [],
            shopifyWebhooks: [
                { text: 'orders/create', value: 'Received every creation of Shopify order.'},
                { text: 'orders/updated', value: 'Received every update of Shopify order.'},
                { text: 'orders/cancelled', value: 'Occurs whenever an order is cancelled.'},
                { text: 'orders/delete', value: 'Occurs whenever an order is deleted.'},
                { text: 'fulfillment_orders/moved', value: 'Shopify order whose location has been changed.'},
                { text: 'fulfillment_orders/split', value: 'Fulfillment order has had items split into a new FO.'},
                { text: 'fulfillment_orders/order_routing_complete', value: 'Occurs when an order has finished being routed and assigned to a fulfillment location.'},
                { text: 'fulfillment_orders/placed_on_hold', value: 'Occurs when a fulfillment order is placed on hold.'},
                { text: 'fulfillment_orders/hold_released', value: 'Occurs when a fulfillment order hold is released.'},
                { text: 'fulfillments/update', value: 'Occurs whenever a fulfillment is updated.'},
                { text: 'app/uninstalled', value: 'Occurs when the app is uninstalled. Clears access token for proper token refresh on reinstall.'},
            ],
            dearWebhooks: [
                { text: 'Sale/QuoteAuthorised', value: 'Triggered when a sales quote is authorised' },
                { text: 'Sale/OrderAuthorised', value: 'Triggered when a sales order is authorised, reserving stock' },
                { text: 'Sale/Voided', value: 'Triggered when a sale is voided (cancelled)' },
                { text: 'Sale/Backordered', value: 'Triggered when a sale is back-ordered' },
                { text: 'Sale/ShipmentAuthorised', value: 'Triggered when a sale shipment is authorised' },
                { text: 'Sale/InvoiceAuthorised', value: 'Triggered when a sales invoice is authorised' },
                { text: 'Sale/PickAuthorised', value: 'Triggered when a sale order is authorised for picking' },
                { text: 'Sale/PackAuthorised', value: 'Triggered when a sale order is authorised for packing' },
                { text: 'Sale/CreditNoteAuthorised', value: 'Triggered when a sales credit note is authorised' },
                { text: 'Sale/Undo', value: 'Triggered when a sale is undone (reverted to draft)' },
                { text: 'Sale/PartialPaymentReceived', value: 'Triggered when partial payment for a sale is received' },
                { text: 'Sale/FullPaymentReceived', value: 'Triggered when full payment for a sale is received' },
                { text: 'Sale/ShipmentTrackingNumberChanged', value: 'Triggered when a sale\’s shipment tracking number is changed' },
            ],
            unleashedWebhooks: [
                {
                    text: 'Sales Order',
                    value: 'salesorder',
                    description: 'Triggered when a new order is created or updated'
                },
                {
                    text: 'Sales Shipment',
                    value: 'salesshipment',
                    description: 'Triggered when a new shipment is created or deleted'
                },
            ],
            bigCommerceWebhooks: [
                { text: 'orders/create', value: 'Triggered when an order is created' },
                { text: 'orders/updated', value: 'Triggered when an order is updated' }
            ]
        }
    },

    mounted() {

        this.fetchWebhooks();
    },

    methods: {

        hasWebhook(text) {
            return this.webhooks.some(function(field) {
                return field.topic === text
            });
        },

        fetchWebhooks() {
            // Guard: ensure required props exist
            if (!this.id || !this.type) {
                return;
            }

            const t = (this.type || '').toLowerCase();

            // Build tips in a generic way per integration
            const configMap = {
                'shopify':       { list: this.shopifyWebhooks,      descKey: 'value' },
                'dear systems':  { list: this.dearWebhooks,         descKey: 'value' },
                'unleashed':     { list: this.unleashedWebhooks,    descKey: 'description' },
                'bigcommerce':   { list: this.bigCommerceWebhooks,  descKey: 'value' },
            };

            this.webhookTips = [];
            const cfg = configMap[t];
            if (cfg && Array.isArray(cfg.list)) {
                this.webhookTips = cfg.list.map(hook => {
                    const desc = hook[cfg.descKey];
                    return desc ? `${hook.text} - ${desc}` : hook.text;
                });
            }

            // Map API type (UI type -> backend route segment)
            let apiType = t === 'dear systems' ? 'dear' : t;
            if (apiType === 'shopify update only') {
                apiType = 'shopify';
            }

            this.$http
                .get('/api/webhooks/' + apiType + '/' + this.id)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.webhooks = (data.result.webhooks || []).map(webhook => {
                            return { topic: webhook.topic, id: webhook.id };
                        });
                    }
                });
        },

        async triggerTopic(topic, isEnabled) {

            let getId = null;
            this.webhooks.map(webhook => {
                if (webhook.topic == topic) {
                    getId = webhook.id
                }
            })

            // stops spam
            if (this.isLoading) {
                return;
            }

            let apiType = this.type.toLowerCase();
            if (apiType === 'dear systems') {
                apiType = 'dear';
            }
            if (apiType === 'shopify update only') {
                apiType = 'shopify';
            }

            try {
                this.isLoading = true

                if (isEnabled) {
                    // User wants to enable webhook - create it
                    let subsData;
                    if (apiType === 'bigcommerce') {
                        let method = null;
                        if (topic === 'orders/create') {
                            method = 'create';
                        } else if (topic === 'orders/updated') {
                            method = 'updated';
                        }
                        subsData = { method };
                    } else {
                        subsData = {
                            'topic':  topic
                        };
                    }
                    this.$http.post('/api/webhooks/'+apiType+'/subscribe/' + this.id, subsData)
                    .then((data) => {
                        if (data.data.code == 200 || data.data.code == 201) {
                            this.fetchWebhooks()
                            EventBus.$emit('show-success', 'Successfully subscribed to ' + topic + '.');
                        }
                        else if (data.data.errors) {
                            // Show detailed error message
                            let errorMsg = Array.isArray(data.data.errors) ? data.data.errors.join(', ') : JSON.stringify(data.data.errors);
                            EventBus.$emit('show-error', 'Failed to subscribe: ' + errorMsg);
                            // Don't refresh webhooks on error to prevent radio button reset
                        } else {
                            EventBus.$emit('show-error', 'Failed to subscribe to ' + topic + '. Unknown error.');
                        }
                        this.isLoading = false
                    })
                    .catch(err => {
                        let errorMsg = 'Failed to subscribe to webhook';
                        if (err.response?.data?.errors) {
                            errorMsg = Array.isArray(err.response.data.errors) ? err.response.data.errors.join(', ') : JSON.stringify(err.response.data.errors);
                        } else if (err.response?.data?.message) {
                            errorMsg = err.response.data.message;
                        } else if (err.message) {
                            errorMsg = err.message;
                        }
                        EventBus.$emit('show-error', errorMsg);
                        // Don't refresh webhooks on error to prevent radio button reset
                        this.isLoading = false
                    })
                }
                else {
                    // User wants to disable webhook - delete it
                    if (getId) {
                        this.$http.get('/api/webhooks/'+apiType+'/delete/' + this.id + '/' + getId)
                        .then((data) => {
                            if (data.data.code == 200) {
                                this.fetchWebhooks()
                                EventBus.$emit('show-success', 'Successfully unsubscribed from ' + topic + '.');
                            }
                            else if (data.data.errors) {
                                let errorMsg = Array.isArray(data.data.errors) ? data.data.errors.join(', ') : JSON.stringify(data.data.errors);
                                EventBus.$emit('show-error', 'Failed to unsubscribe: ' + errorMsg);
                            } else {
                                EventBus.$emit('show-error', 'Failed to unsubscribe from ' + topic + '. Unknown error.');
                            }
                            this.isLoading = false
                        })
                        .catch(err => {
                            let errorMsg = 'Failed to unsubscribe from webhook';
                            if (err.response?.data?.errors) {
                                errorMsg = Array.isArray(err.response.data.errors) ? err.response.data.errors.join(', ') : JSON.stringify(err.response.data.errors);
                            } else if (err.response?.data?.message) {
                                errorMsg = err.response.data.message;
                            } else if (err.message) {
                                errorMsg = err.message;
                            }
                            EventBus.$emit('show-error', errorMsg);
                            this.isLoading = false
                        })
                    } else {
                        // No webhook ID found, just refresh the state
                        this.fetchWebhooks()
                        this.isLoading = false
                        EventBus.$emit('show-warning', 'No webhook found to delete for ' + topic);
                    }
                }

            } catch (err) {
                EventBus.$emit('show-error', err.message || 'An error occurred');
                this.isLoading = false
            }
        }
    }
}
</script>

<style scoped>
.hoverable-list-item {
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
  border-radius: 6px;
}

/* Fallback hover for all themes (works even if theme classes are outside scope) */
.hoverable-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  /* underline without affecting layout */
  box-shadow: inset 0 -1px #e0e0e0;
}

/* Light theme hover */
.theme--light .hoverable-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
  /* underline without affecting layout */
  box-shadow: inset 0 -1px #e0e0e0;
}

/* Dark theme hover */
.theme--dark .hoverable-list-item:hover {
  background-color: rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 -1px rgba(255, 255, 255, 0.2);
}

/* Optional: show the underline when focused via keyboard within the item */
.hoverable-list-item:focus-within {
  box-shadow: inset 0 -1px currentColor;
}
</style>
